import { gtag } from './gtag'

export function mapShareCopyEmbedEvent() {
  gtag('event', 'map_share_copy_embed')
}
